import React from 'react'
import { connect } from 'react-redux'
import { compose, lifecycle, withState } from 'recompose'
import { reduxForm, getFormValues, Field, reset } from 'redux-form'
import { Confirm, Modal, Button } from 'semantic-ui-react'

import FieldInput, { InputType as type } from 'components/SemanticForm'
import { Cont, ModalAction } from './styled'
import {
  createPermission,
  updatePermission,
  deletePermission,
} from 'ducks/roleMan'
import r from 'reactotron-react-js'

import { Toaster } from '@blueprintjs/core'
let toast = Toaster.create({ message: '', show: false })

const FormPermissionModal = props => {
  const {
    handleSubmit,
    data,
    valueForm,
    show,
    title,
    changeShow,
    showConfirm,
    setShowConfirm,
  } = props
  const onDataCreated = (pageSize, setCurrentPage) => itemCount => {
    r.log({ pageSize, setCurrentPage, itemCount })
    if (itemCount <= pageSize) {
      setCurrentPage(0)
    } else {
      let targetPage = Math.ceil(itemCount / pageSize)
      setCurrentPage(targetPage - 1)
    }
  }
  return (
    <div>
      <Modal
        size="tiny"
        open={show}
        closeOnEscape={false}
        closeOnDimmerClick={false}
      >
        <Modal.Header>{title || ''}</Modal.Header>
        <Modal.Content>
          <form onSubmit={handleSubmit(() => setShowConfirm(true))}>
            <Cont>
              <div className="subCont">
                <Field
                  label="Permission Name"
                  name="name"
                  placeholder={''}
                  component={FieldInput}
                  require
                />
              </div>
              <div className="subCont ui form">
                <Field
                  label="Permission Description"
                  name="description"
                  placeholder={''}
                  type={type.textArea}
                  component={FieldInput}
                  require
                />
              </div>
            </Cont>
            <ModalAction>
              {!props.isCreate && (
                <Button
                  onClick={() => props.setIsDelete(true)}
                  type="submit"
                  negative
                >
                  <i className="trash alternate icon"></i>
                  Delete
                </Button>
              )}
              <Button
                onClick={() => closeModal()}
                color={props.isCreate ? 'red' : 'yellow'}
              >
                Cancel
              </Button>
              <Button
                onClick={() => props.setIsDelete(false)}
                type="submit"
                positive
                labelPosition="right"
                icon="save"
                content="Save"
              />
            </ModalAction>
          </form>
        </Modal.Content>
      </Modal>
      <Confirm
        size="mini"
        open={showConfirm}
        onCancel={() => setShowConfirm(false)}
        onConfirm={() => submitModal()}
      />
    </div>
  )

  function submitModal() {
    setShowConfirm(false)
    if (props.isCreate) {
      let hasPermission = props.permissions.find(
        item => item.name.toUpperCase() === valueForm.name.toUpperCase()
      )
      if (hasPermission) {
        toast.clear()
        toast.show({
          message: hasPermission.name + ' was already',
          intent: 'warning',
          timeout: 5000,
        })
        closeModal()
      } else {
        props.createPermission(
          {
            name: valueForm.name,
            description: valueForm.description,
          },
          closeModal,
          onDataCreated(props.tablePageSize, props.setCurrentPage)
        )
      }
    } else if (props.isDelete) {
      props.deletePermission(data.id, closeModal)
    } else {
      let hasPermission = props.permissions.find(item => item.name.toUpperCase() === valueForm.name.toUpperCase())
      let hashasPermissionId = props.permissions.find(item => item.id === data.id)
      if (hasPermission) {
        if (hasPermission === hashasPermissionId) {
          props.updatePermission(
            {
              id: data.id,
              name: valueForm.name,
              description: valueForm.description,
              isDelete: false,
            },
            closeModal,
            onDataCreated(props.tablePageSize, props.setCurrentPage)
          )
        } else {
          toast.clear()
          toast.show({
            message: hasPermission.name + ' was already',
            intent: 'warning',
            timeout: 5000,
          })
          closeModal()
        }
      } else {
        props.updatePermission(
          {
            id: data.id,
            name: valueForm.name,
            description: valueForm.description,
            isDelete: false,
          },
          closeModal,
          onDataCreated(props.tablePageSize, props.setCurrentPage)
        )
      }
    }
  }

  function closeModal() {
    changeShow()
    props.dispatch(reset('formPermissionModal'))
  }
}

const validate = (values, props) => {
  const errors = {}
  if (!values.name) {
    errors.name = 'Required!'
  }
  if (!values.description) {
    errors.description = 'Required!'
  }
  return errors
}

const mapStateToProps = (state, props) => {
  return {
    initialValues: {
      name: props.data ? props.data.name : '',
      description: props.data ? props.data.description : '',
    },
    valueForm: getFormValues('formPermissionModal')(state),
    permissions: state.roleMan.permissions,
  }
}

const mapDispatchToProps = {
  createPermission,
  updatePermission,
  deletePermission,
}

const enhance = compose(
  connect(mapStateToProps, mapDispatchToProps),
  reduxForm({
    form: 'formPermissionModal',
    validate: validate,
    enableReinitialize: true,
  }),
  withState('showConfirm', 'setShowConfirm', false),
  withState('isDelete', 'setIsDelete', false),
  lifecycle({
    componentDidMount() {},
    componentWillReceiveProps(nextProp) {},
  })
)

export default enhance(FormPermissionModal)
